<!-- User Activation Dialog - M3 Design (design.pen Node: ummu1) -->
<!-- PHASE22: Use warning color for deactivation (not danger/red - red is for delete only) -->
<div class="confirm-dialog" [class.confirm-dialog--warning]="accountData?.contractInfo?.contractStatus === 'OPEN'">
  <!-- Header -->
  <div class="confirm-dialog__header">
    <div class="confirm-dialog__title">
      <div class="confirm-dialog__icon-wrapper" [class.confirm-dialog__icon-wrapper--warning]="accountData?.contractInfo?.contractStatus === 'OPEN'" [class.confirm-dialog__icon-wrapper--primary]="accountData?.contractInfo?.contractStatus === 'CLOSE'">
        <mat-icon>{{ accountData?.contractInfo?.contractStatus === 'OPEN' ? 'person_off' : 'person' }}</mat-icon>
      </div>
      <span>{{ accountData?.contractInfo?.contractStatus === 'OPEN' ? 'アカウント停止' : 'アカウント有効化' }}</span>
    </div>
    <button mat-icon-button class="confirm-dialog__close" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="confirm-dialog__content">
    @if (isLoading()) {
      <!-- Skeleton Loading -->
      <div class="skeleton-form">
        <div class="skeleton-user-info">
          <div class="skeleton skeleton--name"></div>
          <div class="skeleton skeleton--meta"></div>
        </div>
        <div class="skeleton skeleton--warning-box"></div>
      </div>
    } @else if (accountData?.contractInfo?.contractStatus === 'OPEN') {
      <div class="confirm-dialog__user-info">
        <div class="confirm-dialog__user-name">{{ ConcatenateUserName(accountData?.user) }}</div>
        <div class="confirm-dialog__user-meta">ユーザー</div>
      </div>
      <div class="confirm-dialog__warning-box">
        <mat-icon>warning</mat-icon>
        <p i18n="@@adminSection.userActivation.message.deactivateWarning">
          ユーザーアカウントを停止すると、計測と情報の閲覧ができなくなります。後から再開することも可能です。
        </p>
      </div>
    } @else if (accountData?.contractInfo?.contractStatus === 'CLOSE') {
      <div class="confirm-dialog__user-info">
        <div class="confirm-dialog__user-name">{{ ConcatenateUserName(accountData?.user) }}</div>
        <div class="confirm-dialog__user-meta">ユーザー（停止中）</div>
      </div>
      <p class="confirm-dialog__message" i18n="@@adminSection.userActivation.message.reactivateInfo">
        このユーザーアカウントを有効化すると、再び計測と情報の閲覧が可能になります。
      </p>
    }
  </div>

  <!-- Footer -->
  <div class="confirm-dialog__footer">
    <button mat-stroked-button (click)="onNoClick()">
      <span i18n="@@adminSection.userActivation.button.cancel">閉じる</span>
    </button>

    @if (accountData?.contractInfo?.contractStatus === 'OPEN') {
      <button mat-flat-button color="accent" [disabled]="isSending()" (click)="deactivate()">
        @if (isSending()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <mat-icon>person_off</mat-icon>
        }
        <span i18n="@@adminSection.userActivation.button.deactivate">停止する</span>
      </button>
    } @else if (accountData?.contractInfo?.contractStatus === 'CLOSE') {
      <button mat-flat-button color="primary" [disabled]="isSending()" (click)="reactivate()">
        @if (isSending()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <mat-icon>person</mat-icon>
        }
        <span i18n="@@adminSection.userActivation.button.reactivate">有効化する</span>
      </button>
    }
  </div>
</div>
